export function setBooleanToInt(value) {
  return value ? 1 : 0;
}
